/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const GlidepathStackedChartWithSlider = ({ onInputSubmit, GlidepathStackedChartWithSliderLabels, maxYear = '25' }) => {
  useEffect(() => {
    document.addEventListener('change', (event) => {
      if (event.target.classList.contains('input-slider')) {
        const inputValue = event.target.value;
        if (onInputSubmit) {
          onInputSubmit(Number(inputValue), false);
        }
      }
    });
  }, [onInputSubmit]);

  const { t } = useTranslation();
  const minInputValue = 1;
  const maxInputValue = Number(maxYear);

  return (
    <>
      <div className="l-container stacked-percent-section">
        <h6 className="c-heading u-text-align-center u-margin-bottom-m u-margin-top-m" tabIndex="0">
          {GlidepathStackedChartWithSliderLabels?.stackedChartHeading}
        </h6>
        <div id="mySlider" className="slidecontainer">
          <div className="progress-out"></div>
          <div className="progress-in"></div>
          <input type="range" min={minInputValue} max={maxInputValue} defaultValue="1" className="input-slider js-toggle-tooltip__link" />
          <div className="c-tooltip c-tooltip--v2 c-tooltip--top">
            <div role="tooltip" className="c-tooltip__item is-open" aria-hidden="true">
              <div className="c-tooltip__arrow"></div>
              <span id="slider-tooltip">{maxYear} {t('yearsLabel')}</span>
            </div>
          </div>
        </div>
        <div className="stacked-area-container"></div>
      </div>
      <div className="stacked-area-legends"></div>
    </>
  )
}

export default GlidepathStackedChartWithSlider;
